/**
 * A simple slugify function that can be used on server and browser.
 * Feel free to adapt this function
 */

export function slugify(str: string) {
  return str
    .toLowerCase()
    .replace(/[^\w ]+/g, "")
    .replace(/_+/g, "-")
    .replace(/ +/g, "-")
}
